export default __webpack_public_path__ + "static/media/6.0ec1d2bb.jpg";